








































import Vue from "vue";

// Model
import { MachineStatus } from "@/model/data/status/MachineStatus";
import { Stock } from "@/model/data/Stock";

import { statusEnumLabel } from "@/model/data/status/StatusEnum";
import { CleaningStatusTypeEnum, cleaningStatusEnumLabel } from "@/model/data/status/CleaningStatusTypeEnum";
import { DoorStatusTypeEnum, doorStatusEnumLabel } from "@/model/data/status/DoorStatusTypeEnum";
import { CoverStatusTypeEnum, coverStatusEnumLabel } from "@/model/data/status/CoverStatusTypeEnum";
import { BagStatusTypeEnum, bagStatusEnumLabel } from "@/model/data/status/BagStatusTypeEnum";
import { BundlerStatusTypeEnum, bundlerStatusEnumLabel } from "@/model/data/status/BundlerStatusTypeEnum";
import { getStatusIconColor } from "@/utility/Constants";
import { stockTypeEnumLabel } from "@/model/data/enums/StockTypeEnum";

const i18nMachineStatusRoot = "device_status.machine_status_attribute";

export default Vue.extend({
    data() {
        return {
            notSupportedBagModels: ["DropVault"],
        };
    },
    props: {
        machineStatus: { type: Object as () => MachineStatus, required: true },
        model: String,
        stocksConfig: { type: Array as () => Array<Stock> },
    },
    computed: {
        machineStatusAttributes() {
            let res = [];
            if (this.machineStatus == null) return res;

            res.push({
                name: "status",
                i18nName: "common.status",
                i18nValue: this.statusEnumLabel,
            });

            if (this.machineStatus.cleaningStatus != CleaningStatusTypeEnum.NotNecessary && this.machineStatus.cleaningStatus != CleaningStatusTypeEnum.Unknown)
                res.push({
                    name: "cleaningStatus",
                    i18nName: i18nMachineStatusRoot + ".cleaning_status",
                    i18nValue: this.cleaningStatusEnumLabel,
                });

            if (this.machineStatus.doorStatus != DoorStatusTypeEnum.Closed && this.machineStatus.doorStatus != DoorStatusTypeEnum.Unknown)
                res.push({
                    name: "doorStatus",
                    i18nName: i18nMachineStatusRoot + ".door_status",
                    i18nValue: this.doorStatusEnumLabel,
                });

            if (this.machineStatus.coverStatus != CoverStatusTypeEnum.Closed && this.machineStatus.coverStatus != CoverStatusTypeEnum.Unknown)
                res.push({
                    name: "coverStatus",
                    i18nName: i18nMachineStatusRoot + ".cover_status",
                    i18nValue: this.coverStatusEnumLabel,
                });

            if (
                this.machineStatus.bagStatus != BagStatusTypeEnum.Ok &&
                this.machineStatus.bagStatus != BagStatusTypeEnum.Unknown &&
                this.machineStatus.bagStatus != BagStatusTypeEnum.Unsupported &&
                !this.notSupportedBagModels.includes(this.model)
            ) {
                res.push({
                    name: "bagStatus",
                    i18nName: i18nMachineStatusRoot + ".bag_status",
                    i18nValue: this.bagStatusEnumLabel,
                });
            }

            if (
                this.machineStatus.bundlerStatus != BundlerStatusTypeEnum.Ok &&
                this.machineStatus.bundlerStatus != BundlerStatusTypeEnum.Unknown &&
                this.machineStatus.bundlerStatus != BundlerStatusTypeEnum.Unsupported
            ) {
                res.push({
                    name: "bundlerStatus",
                    i18nName: i18nMachineStatusRoot + ".bundler_status",
                    i18nValue: this.bundlerStatusEnumLabel,
                });
            }

            return res;
        },
    },
    methods: {
        getStatusIconColor,
        statusEnumLabel,
        cleaningStatusEnumLabel,
        doorStatusEnumLabel,
        coverStatusEnumLabel,
        bagStatusEnumLabel,
        bundlerStatusEnumLabel,
        getBlockedStockType(blockedStock: number){
            if(this.stocksConfig && this.stocksConfig.length > blockedStock && this.stocksConfig[blockedStock] ){
                let stockType = this.$t(stockTypeEnumLabel(this.stocksConfig[blockedStock].stockType))
                return `${stockType} ${this.stocksConfig[blockedStock].index+1}`;
            }
            return "";
        },
        getBlockedStockDenomination(blockedStock: number){
            if(this.stocksConfig && this.stocksConfig.length > blockedStock && this.stocksConfig[blockedStock] ){
                let denomination = this.stocksConfig[blockedStock].denominations[0];
                let value = denomination.value.toFixed(2).replace(/[.,]00$/, "");
                return `${value} ${denomination.currency}`
            }
            return "";
        }
    },
});
